import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import HomepageFeaturedCollectionTile from '../HomepageFeaturedCollectionTile';
import styles from './styles.scss';

export default function HomepageFeaturedCollections({ collections, onClick }) {
  if (collections.length === 0) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.title}>{i18n.gettext("What's on the menu?")}</div>
        <div className={styles.tiles}>
          {collections.map((tag, id) => {
            const rowId = Math.floor(id / 2);
            let options;
            let itemWidth;

            if (rowId % 2 === 0) {
              options = ['40%', '60%'];
            } else {
              options = ['60%', '40%'];
            }

            itemWidth = id % 2 === 0 ? options[0] : options[1];

            if (tag.length % 2 !== 0 && id === tag.length - 1) {
              // I'm so, so sorry.
              itemWidth = '100% !important';
            }

            return (
              <HomepageFeaturedCollectionTile
                {...tag}
                key={tag.id}
                onClick={onClick}
                width={itemWidth}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

HomepageFeaturedCollections.propTypes = {
  collections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.string,
    }),
  ).isRequired,
  onClick: PropTypes.func.isRequired,
};
